<template>
    <div>
        <div class="
        w-full p-4 bg-white tracking-wide text-gray-800
        rounded border border-b-8 shadow-md hover:outline-none focus:outline-none active:outline-none
        py-2 px-6 inline-flex items-center"
             v-bind:class="[newCatalog.catalog[this.page].points[this.subpage].status === true ? 'border-green-500': 'border-red-500']"
        >
            <div class="mx-auto text-center">
                <p class="md:text-xl text-xl font-extrabold leading-tight"
                   v-html="newCatalog.catalog[this.page].points[this.subpage].name"></p>
                <p class="md:text-3xl text-md font-bold m-4 leading-tight">
                    <span v-html="newCatalog.catalog[this.page].points[this.subpage].description"></span>
                </p>
                <p class="md:text-xl text-normal">
                    <slot name="notice"></slot>
                </p>
            </div>

        </div>

        <div class="w-full mt-4 mb-2 text-md">Notiz:</div>
        <textarea class="
                  w-full p-2 bg-white tracking-wide text-gray-800 text-sm
                  rounded border border-b-4 shadow-md hover:outline-none focus:outline-none active:outline-none
                  "
                rows="3"
                v-model="notice"
        ></textarea>

        <div class="flex-grow">
            <div class="flex flex-wrap md:mt-12 mt-6">
                <div class="w-1/2 p-4 pl-0">
                    <button
                            class="
                    w-full md:h-32 h-20 tracking-wide text-white text-4xl
                    bg-red-500 border-red-500 border-gray-500 rounded border border-b-8
                    shadow-md hover:outline-none focus:outline-none active:outline-none
                    py-2 px-6 inline-flex items-center"
                            @click="onClick(false)"
                    >
                    <span class="mx-auto">
                        <svg class="fill-current text-teal inline-block h-12 w-12" xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 20 20">
                          <path d="M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"/>
                        </svg>
                    </span>
                    </button>
                </div>

                <div class="w-1/2 p-4 pr-0">
                    <button
                            class="
                    w-full md:h-32 h-20 tracking-wide text-white text-4xl
                    bg-green-500 border-green-500 border-gray-500 rounded border border-b-8
                    shadow-md hover:outline-none focus:outline-none active:outline-none
                    py-2 px-6 inline-flex items-center"
                            @click="onClick(true)"
                    >
                    <span class="mx-auto">
                        <svg class="fill-current text-teal inline-block h-12 w-12" xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 20 20">
                          <path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/>
                        </svg>
                    </span>
                    </button>
                </div>
            </div>
        </div>

        <div class="md:mt-20 mt-4 flex justify-between">
            <div class="w-1/4 p-4 pl-0">
                <button v-if="this.newCatalog.position.prev"
                        class="
                        w-full h-12 tracking-wide text-gray-600 text-4xl
                        border-gray-500 rounded border
                        shadow-md hover:outline-none focus:outline-none active:outline-none
                        py-1 px-4 inline-flex items-center"
                        @click="prev()"
                >
                <span class="mx-auto">
                    <svg class="fill-current text-teal inline-block md:h-12 md:w-12 h-6 w-6" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						<g id="Page-1" stroke="none" stroke-width="1" fill="fill-current" fill-rule="evenodd">
							<g id="icon-shape">
								<polygon id="Combined-Shape" points="7.05025253 9.29289322 6.34314575 10 12 15.6568542 13.4142136 14.2426407 9.17157288 10 13.4142136 5.75735931 12 4.34314575"></polygon>							</g>
						</g>
                    </svg>
                </span>
                </button>
            </div>

            <div class="w-1/4 p-4 pr-0">
                <button v-if="this.newCatalog.position.next"
                        class="
                        w-full h-12 tracking-wide text-gray-600 text-4xl
                        border-gray-500 rounded border
                        shadow-md hover:outline-none focus:outline-none active:outline-none
                        py-1 px-4 inline-flex items-center"
                        @click="next()"
                >
                <span class="mx-auto">
                    <svg class="fill-current text-teal inline-block md:h-12 md:w-12 h-6 w-6" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						<g stroke="none" stroke-width="1" fill="fill-current" fill-rule="evenodd">
							<g id="icon-shape">
								<polygon id="Combined-Shape" points="12.9497475 10.7071068 13.6568542 10 8 4.34314575 6.58578644 5.75735931 10.8284271 10 6.58578644 14.2426407 8 15.6568542 12.9497475 10.7071068"></polygon>
							</g>
						</g>
                    </svg>
                </span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            //console.log(newCatalog)
        },

        props: ['user_id', 'content', 'page', 'subpage', 'action'],

        data() {
            return {
                state: false,
                newCatalog: this.content,
                timestamp_start: new Date().getTime(),
                current_duration: 0,
                notice: this.content.catalog[this.page].points[this.subpage].notice
            }
        },

        methods: {
            onClick(state) {
                this.state = state;
                this.newCatalog.catalog[this.page].points[this.subpage].status = state;
                this.timestamp_end = new Date().getTime();
                this.current_duration = Math.floor((this.timestamp_end - this.timestamp_start) / 1000);

                this.newCatalog.catalog[this.page].points[this.subpage].user_id = this.user_id;
                this.newCatalog.catalog[this.page].points[this.subpage].duration = this.newCatalog.catalog[this.page].points[this.subpage].duration + this.current_duration;
                this.newCatalog.catalog[this.page].points[this.subpage].notice = this.notice;

                this.save('/'+this.action+'/'+this.newCatalog.uuid+'/'+this.newCatalog.position.next);
            },
            prev() {
                window.location.href = '/'+this.action+'/'+this.newCatalog.uuid+'/'+this.newCatalog.position.prev;
            },
            next() {
                if (this.newCatalog.catalog[this.page].points[this.subpage].status == null) {
                    this.newCatalog.catalog[this.page].points[this.subpage].status = false;
                }
                this.newCatalog.catalog[this.page].points[this.subpage].duration = this.newCatalog.catalog[this.page].points[this.subpage].duration + this.newCatalog.catalog[this.page].points[this.subpage].duration;

                this.save('/'+this.action+'/'+this.newCatalog.uuid+'/'+this.newCatalog.position.next);
                //window.location.href = '/checkin/'+this.newCatalog.uuid+'/'+this.newCatalog.position.next;
            },
            save(location) {
                axios.post('/'+this.action+'/'+this.newCatalog.uuid, {data: this.newCatalog})
                    .then((response)=>{
                        window.location.href = location;
                    }).catch((error)=>{
                        console.log(error.response.data)
                    });
            }
        }
    }
</script>
